import React, { useContext } from 'react';
import { Spacer, Text, ArrowLink } from 'react-onei';

import TagService from '../../../../services/TagService';
import { events } from '../../../../conf/tags_ga.conf';
import UserContext from '../../../../context/UserContext';

const UseTemporaryPassword = () => {
    const { wording, serviceConf } = useContext(UserContext);
    const { tempPasswordUrl } = serviceConf
    const { WLOST_220, WLOST_221, WLOST_222 } = wording;

    return (
        <div className="spacing-xs">
            <Text variant="lead" id="use-tmp-password-label">
                <strong>
                    {WLOST_220}
                </strong>
            </Text>
            <Text id="use-tmp-password-indication">
                {WLOST_221}
            </Text>
            <ArrowLink
                href={tempPasswordUrl}
                id="use-tmp-password-link"
                onClick={() => TagService.sendEvent(events.useTemporaryPassword)}
                aria-label={WLOST_222}
                title={WLOST_222}
                fullWidth
            >
                {WLOST_222}
            </ArrowLink>
            <Spacer color="grey4" className="spacing-xs" />
        </div>
    )
}

export default UseTemporaryPassword;